import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
  name: 'sanitizeHtml',
  standalone: false,
})
export class SanitizeHtmlPipe implements PipeTransform {
  private readonly sanitized = inject(DomSanitizer);

  transform(value: any): any {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
